import React from "react";
import ErrorPage from "../pages/ErrorPage";

class ErrorBoundary extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      if(this.props.customHandler)
        return (<>{this.props.customHandler}</>);
      else
        return (
          <>
            <ErrorPage>
            </ErrorPage>
          </>
        );
    }

    return (
      <>
        {this.props.children}
      </>);
  }
}

export default ErrorBoundary;